import { useQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Divider, FluentProvider, webLightTheme } from '@fluentui/react-components';
import {
  cardContentWrapperStyles,
  dividerStyles,
} from '../../../app/common/styles/CommonStyleObjects';
import { GET_COMPANY_PROCESS_EXTENSTION_DOCUMENTS } from '../../../utils/statApi/CompaniesApi';
import { ICompanyCodeParams } from '../../common/ParamTypes';
import DocumentCardList from '../../common/documents/DocumentCardList';
import { IDocument } from '../../../utils/statApi/DocumentApi';

interface IProcessExtensionDocumentsProps {
  showDeletedFiles: boolean;
}

const ProcessExtensionDocuments = ({
  showDeletedFiles,
}: IProcessExtensionDocumentsProps): JSX.Element => {
  const { companyCode } = useParams<ICompanyCodeParams>();
  const styles = dividerStyles();
  const { data, loading, error } = useQuery(GET_COMPANY_PROCESS_EXTENSTION_DOCUMENTS, {
    variables: {
      companyCode,
      showDeletedFiles,
    },
    fetchPolicy: 'network-only',
  });

  const companyDocuments: IDocument[] = data?.companyProcessExtensionDocuments || [];

  return (
    <div className={cardContentWrapperStyles}>
      <FluentProvider theme={webLightTheme}>
        <Divider className={styles.divider} />
      </FluentProvider>
      <DocumentCardList
        loading={loading}
        error={error}
        docType="ProcessExtension"
        documents={companyDocuments}
        showDeletedFiles={showDeletedFiles}
      />
    </div>
  );
};

export default ProcessExtensionDocuments;
